export function normalizeOptionalMetadata(
  value: string | null | undefined,
): string | null {
  return value?.trim() || null;
}
